import { useContext } from "react";
import { GlobalContext } from "../Context";
import { Box, Typography } from "@mui/material";
import CompetitionDDL from "../../Pages/SafeRoads/components/CompetitionDDL";
import { useTranslation } from "react-i18next";

const ErrorNoCompPage = ({ currCompetition, setCurrCompetition }) => {
  const { mobileView, tabletView } = useContext(GlobalContext);
  const { t } = useTranslation("Navigation");

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    height: "70vh",
    justifyContent: "center",
    alignItems: "center",
    p: mobileView ? 0 : tabletView ? "0 20%" : "0 35%",
    textAlign: "center",
  };
  const imageStyle = {
    width: "6rem",
    mb: "1rem",
  };
  const titleStyle = {
    fontSize: "1.625rem",
    fontWeight: 700,
    lineHeight: 1.25,
  };
  const descStyle = {
    fontSize: "1rem",
    fontWeight: 500,
    opacity: 0.5,
    lineHeight: 1.25,
    width: "75%",
    m: "1rem 0 1.5rem",
  };

  return (
    <Box sx={containerStyle}>
      <Box
        component="img"
        src="/images/safeRoads/SRC-Pins.png"
        alt="Safe Roads Logo"
        sx={imageStyle}
      />
      <Typography sx={titleStyle}>{t("noCompTitle")}</Typography>
      <Typography sx={descStyle}>{t("noCompDesc")}</Typography>
      <Box sx={{ width: "80%" }}>
        <CompetitionDDL
          setCurrCompetition={setCurrCompetition}
          currCompetition={currCompetition}
          full={mobileView || tabletView}
        />
      </Box>
    </Box>
  );
};

export default ErrorNoCompPage;
